(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.header) {
        this.header.classList.add('shopify-section-header-sticky');
      }
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_2026"]) return;
  try {
    
  /* Evita pisar Dawn si ya existe el custom element */
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.setHeaderHeight = this.setHeaderHeight.bind(this);
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight);
        if (this.header) this.header.classList.add('shopify-section-header-sticky');
      }
      setHeaderHeight() {
        if (!this.header) return;
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
